export default __webpack_public_path__ + "./fonts/right-arrow.f95ab6aa2980dd28f9ff741bcd441deb.svg";